module.exports = __webpack_public_path__ + "static/media/thermometer.14eb83b4.png";